/**
 * Payment-due (chase list) report — GET /v1/reports/payment-due (Prompt
 * 11E.8). The admin dashboard's pending-payments widget reads this
 * directly (the office dashboard gets the same data bundled inside
 * GET /v1/dashboard/office — one backend source, two frontend call sites).
 */

import { useQuery } from '@tanstack/react-query';
import { api } from '@core/api/client';
import type { PaymentDueReport, PaymentDuePeriod } from '@/api/dashboard';

export function usePaymentDue(period: PaymentDuePeriod = 'this_month') {
  return useQuery<PaymentDueReport>({
    queryKey: ['reports', 'payment-due', period],
    queryFn: () => api.get<PaymentDueReport>('/v1/reports/payment-due', { query: { period } }),
    staleTime: 30_000,
  });
}
